import { useEffect, type ReactNode } from "react";
import {
  BuilderRecipeProvider,
  useBuilderRecipeDispatch,
} from "./state/recipe-store";
import {
  BuilderDraftSessionProvider,
  useBuilderDraftSession,
} from "./state/create-session-store";
import { CheckoutSessionProvider } from "./state/checkout-session-store";

/** React owns this state above auth/wallet tree swaps; SSR gets a fresh empty session. */
export function DirectIndexSessionProvider(props: {
  readonly children: ReactNode;
  readonly pathname: string;
}) {
  return (
    <CheckoutSessionProvider>
      <BuilderRecipeProvider>
        <BuilderDraftSessionProvider>
          <BuilderRouteReset pathname={props.pathname} />
          {props.children}
        </BuilderDraftSessionProvider>
      </BuilderRecipeProvider>
    </CheckoutSessionProvider>
  );
}

function BuilderRouteReset(props: { readonly pathname: string }) {
  const resetRecipe = useBuilderRecipeDispatch();
  const {
    previousOwnerRef,
    attemptedGuestClaimOwnerKeyRef,
    setStoredDraftScope,
    dispatchDraftSession,
  } = useBuilderDraftSession();
  useEffect(() => {
    if (props.pathname === "/build") return;
    resetRecipe({ type: "reset" });
    previousOwnerRef.current = null;
    attemptedGuestClaimOwnerKeyRef.current = null;
    setStoredDraftScope(null);
    dispatchDraftSession({
      type: "replace",
      hasPreservedGuestDraft: false,
      scope: null,
    });
  }, [
    props.pathname,
    resetRecipe,
    previousOwnerRef,
    attemptedGuestClaimOwnerKeyRef,
    setStoredDraftScope,
    dispatchDraftSession,
  ]);
  return null;
}
